import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import type { GetTreatmentAdherenceArgs, TreatmentAdherence } from "api/services/patient/schemas/treatment_adherence";
import { useApiClient } from "api/useApiClient";

type QueryKey = ["getTreatmentAdherence", GetTreatmentAdherenceArgs];
const getTreatmentAdherenceQueryKey = (args: GetTreatmentAdherenceArgs): QueryKey => ["getTreatmentAdherence", args];

export const useGetTreatmentAdherence = (
  args: GetTreatmentAdherenceArgs,
  options?: UseQueryOptions<TreatmentAdherence, Error, TreatmentAdherence, QueryKey>
) => {
  const client = useApiClient();

  return useQuery(getTreatmentAdherenceQueryKey(args), () => client.getTreatmentAdherence(args), options);
};
